import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=71f082b5&"
import script from "./Introduction.vue?vue&type=script&lang=js&"
export * from "./Introduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f082b5')) {
      api.createRecord('71f082b5', component.options)
    } else {
      api.reload('71f082b5', component.options)
    }
    module.hot.accept("./Introduction.vue?vue&type=template&id=71f082b5&", function () {
      api.rerender('71f082b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VueFormComponents/Introduction/Introduction.vue"
export default component.exports